import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { SITE_CONFIG } from "../data/mockData";
import { fetchActiveCategories } from "../services/api";
import { Facebook } from "lucide-react";

const Footer = () => {
  const [activeCategories, setActiveCategories] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        const cats = await fetchActiveCategories();
        setActiveCategories(cats);
      } catch (err) {
        console.error("Failed to load categories:", err);
      }
    };
    load();
  }, []);

  return (
    <footer className="bg-[#111111] text-white mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer */}
        <div className="py-12 grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img
                src={SITE_CONFIG.logo}
                alt={SITE_CONFIG.name}
                className="h-10 w-auto brightness-0 invert"
              />
              <span className="text-lg font-black">ON THE COUNTER</span>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              Different Views. Same Passion. Your home for bold sports opinions and analysis across every major sport.
            </p>
            <a
              href="https://www.facebook.com/profile.php?id=61594078029196"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-white/10 hover:bg-[#1877F2] text-sm font-medium transition-colors duration-200"
            >
              <Facebook size={16} />
              Follow us on Facebook
            </a>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-gray-400 mb-4">
              Categories
            </h4>
            <ul className="space-y-2.5">
              {activeCategories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.id}`}
                    className="text-sm text-gray-300 hover:text-[#1B7A3D] transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-500">
            © 2025 On The Counter. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/" className="text-xs text-gray-500 hover:text-gray-300 transition-colors">
              Privacy Policy
            </Link>
            <Link to="/" className="text-xs text-gray-500 hover:text-gray-300 transition-colors">
              Terms of Use
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
